import { isAfter, isBefore, subDays } from 'date-fns'
import { Capacitor } from '@capacitor/core'

import Api from 'services/Api'
import { decodeToken, setLoggedOut } from 'store/actions/auth'
import { createErrorNotification } from 'store/actions/notifications'
import { zodiaqueSign } from 'services/Utilities'
import { Parse } from 'services/Dates'

export const setUserInfo = () => {
  return async (dispatch, getStore) => {
    const { uid: _id, punchToken: isPunchToken } = decodeToken()

    if (!isPunchToken) {
      // Tell PrivateRoute that we are starting to fetch the user's information
      dispatch({ type: 'SET_IS_LOADING_USER_INFO' })

      const { users, success } = await Api.get('/users/users', { params: { _id, getPasswordChangeInfo: true } })
      // If an error happen from the backend, logout the user and display a notification message
      if (!success) {
        dispatch(createErrorNotification())
        return setLoggedOut({ dispatch, getStore })
      }

      const { hiringData = [], ...user } = users[0]

      // Get all unexpired contracts
      const currentHiringData = hiringData.filter(data => {
        const contractExpired = data.end && isAfter(new Date(), Parse(data.end, { inFormat: 'date' }))
        const contractNotStarted = data.start && isBefore(new Date(), Parse(data.start, { inFormat: 'date' }))
        return !contractExpired && !contractNotStarted
      })

      // Set the user's informations into the store
      dispatch({ type: 'SET_USER_INFO', userInfo: { ...user, hiringData, currentHiringData } })

      // Adds more information to intercom
      if (window.intercomSettings && window.Intercom) {
        window.intercomSettings.phone = users[0].phoneNumbers.map(phone => phone.phoneNumber).join(', ')
        window.intercomSettings.email = users[0].emails.map(email => email.address).join(', ')
        window.intercomSettings.zodiaque = zodiaqueSign(users[0].birthDate)
        window.Intercom('update', window.intercomSettings)
      }
      // Tell PrivateRoute that we are done fetching the user's information
      dispatch({ type: 'REMOVE_IS_LOADING_USER_INFO' })
    }
  }
}

// User info should be refetched after a while
export const checkIfUsersRefreshIsNeeded = () => {
  return async (dispatch, getStore) => {
    // If we are in the browser, skip
    if (!Capacitor.isNativePlatform()) return

    // Get the lastRefreshedAt from the store
    const {
      users: { lastRefreshedAt }
    } = getStore()
    // Resources have not been fetched yet, skip
    if (!lastRefreshedAt) return

    const nowLessOneDay = subDays(new Date(), 1)
    if (isAfter(nowLessOneDay, lastRefreshedAt)) dispatch(setUserInfo())
  }
}
